<ui-bottom-sheet
  [open]="open()"
  title="Dostęp i udostępnianie"
  description="Decydujesz, kto widzi tę wishlistę i kto może rezerwować prezenty."
  closeLabel="Zamknij"
  [closeIcon]="true"
  [showHandle]="false"
  size="lg"
  snap="large"
  (closed)="handleClosed()"
>
  <div
    class="wishlist-access-sharing-drawer"
    data-testid="wishlist-access-sharing-drawer"
  >
    @let currentView = view();

    @if (currentView) {
      @if (currentView.feedback) {
        <ui-inline-message
          [text]="currentView.feedback"
          tone="success"
          ariaLive="polite"
        />
      }

      @if (currentView.error) {
        <ui-inline-message
          [text]="currentView.error"
          tone="danger"
          ariaLive="polite"
        />
      }

      <section class="access-sharing-section">
        <h3>Widoczność</h3>
        <ui-choice-group
          data-testid="wishlist-access-visibility-option"
          ariaLabel="Widoczność wishlisty"
          layout="stack"
          [options]="options()"
          [selectedOptionId]="currentView.visibility"
          (selectedOptionIdChange)="handleVisibilityOptionSelected($event)"
        />
      </section>

      <wishlist-access-panel
        [view]="currentView"
        (createLinkSelected)="handleCreateLinkSelected()"
        (copyLinkSelected)="handleCopyLinkSelected()"
        (rotateLinkSelected)="handleRotateLinkSelected()"
        (disableLinkSelected)="handleDisableLinkSelected()"
      />

      @if (shouldShowInvitations()) {
        <section class="access-sharing-section">
          <h3>Zaproszone osoby</h3>

          @if (shouldShowInviteComposer()) {
            <div class="access-sharing-invite">
              <ui-input
                label="Email zaproszonej osoby"
                name="wishlistInviteEmail"
                type="email"
                autocomplete="email"
                placeholder="np. babcia@example.com"
                [value]="invitedEmail()"
                [errorText]="invitedEmailError()"
                [disabled]="currentView.pending"
                (valueChange)="handleInviteEmailChanged($event)"
              />
              <ui-button
                size="sm"
                variant="secondary"
                [disabled]="!canSubmitInvite()"
                (pressed)="handleInviteSubmitted()"
              >
                Dodaj email
              </ui-button>
            </div>
          } @else {
            <p class="access-sharing-empty">
              Zaproszenia są aktywne tylko w widoczności „Zaproszone osoby”.
            </p>
          }

          @if (currentView.invitations.length > 0) {
            <ul
              class="access-sharing-invitation-list"
              aria-label="Zaproszone osoby"
            >
              @for (
                invitation of currentView.invitations;
                track invitation.id
              ) {
                <li>
                  <span class="access-sharing-invitee">
                    <strong>{{ invitation.email }}</strong>
                    <small>{{ invitation.invitedAtLabel }}</small>
                  </span>
                  <wishlist-status-pill
                    [label]="invitation.statusLabel"
                    [tone]="invitation.statusTone"
                  />
                  <ui-button
                    size="sm"
                    variant="ghost"
                    [disabled]="currentView.pending"
                    (pressed)="handleInvitationRemoved(invitation.id)"
                  >
                    Usuń dostęp
                  </ui-button>
                </li>
              }
            </ul>
          } @else {
            <p class="access-sharing-empty">
              Dodaj email osoby, która ma zobaczyć tę wishlistę bez publicznego
              linku.
            </p>
          }
        </section>
      }

      <p class="access-sharing-privacy">
        Goście widzą tylko dane tej wishlisty — bez prywatnych danych domu ani
        innych list.
      </p>
    } @else {
      @if (fallbackError()) {
        <ui-inline-message
          [text]="fallbackError() ?? ''"
          tone="danger"
          ariaLive="polite"
        />
      } @else if (loading()) {
        <p class="access-sharing-empty">Ładuję ustawienia dostępu.</p>
      }
    }
  </div>
</ui-bottom-sheet>
